/* eslint-disable max-statements */
/* eslint-disable no-mixed-spaces-and-tabs */
import { useEffect, useRef, useState } from 'react';
import React from 'react';

import { useMutation } from 'react-query';
import validator from 'validator';
import { stateNotificationsEnum } from '../../Utils/notification';
import './css/addImageModal.css';
import Quote from '../../SubSections/Topic/quote';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import { useDispatch } from 'react-redux';
import { SetNotificationAction } from '../../../redux/actions/notificationAction';
import { globalEnv } from '../../../config/baseConfig';
import SaveButton from '../../Utils/saveButton';
import moment from 'moment';
import { DatePickerComponent } from '../../Utils/Components/datePicker/datePicker';
import { axiosInstance } from '../../../config/axiosInstance';

type props = {
	setModalOpen: (isOpen: boolean) => void;
	topicId: string;
	imageId: any;
	images: any[];
	setImages: (images: any[]) => void;

	isChanged: boolean;
	setIsChanged: (isChanged: boolean) => void;
	isWarnModalOpen: boolean;
	setIsWarnModalOpen: (isOpen: boolean) => void;
};

export default function EditImageModalContent({
	setModalOpen,
	topicId,
	imageId,
	images,
	setImages,
	isChanged,
	setIsChanged,
	isWarnModalOpen,
	setIsWarnModalOpen
}: props) {
	const cancelButtonRef = useRef(null);

	useEffect(() => {
		// const imagesCopy = images.slice();
		// image = imagesCopy.find((image) => image._id == imageId);
		return () => {
			console.log('Unmount!');
		};
	}, []);

	const imagesCopy = images.slice();
	const image = imagesCopy.find((image) => image._id == imageId);

	const [title, setTitle] =
		image != null
			? image.title != null
				? useState(image.title)
				: useState('')
			: useState('');
	const [titleErrorMsg, setTitleErrorMsg] = useState({
		message: '',
		error: false
	});
	const [photographer, setPhotographer] =
		image != null ? useState(image.photographer) : useState('');
	const [info, setInfo] = image != null ? useState(image.info) : useState('');
	const [source, setSource] =
		image != null ? useState(image.source) : useState('');
	const [location, setLocation] =
		image != null ? useState(image.location) : useState('');
	const [date, setDate] = useState<any>(
		moment(image.date).isValid() ? moment(image.date).toDate() : new Date()
	);

	// const [isChanged, setIsChanged] = useState(false);
	const [quotes, setQuotes] =
		image != null ? useState<any[]>(image.quotes) : useState<any[]>([]);

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const dispatch = useDispatch();

	const saveImageReq = async () => {
		const dto = {
			title: title,
			info: info,
			source: source,
			photographer: photographer,
			location: location,
			date: date,
			quotes: quotes
		};
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axiosInstance.put(
			`${globalEnv.BASE_URL}/topic/${topicId}/media/${image._id}/update`,
			dto,
			config
		);
		return response;
	};

	const { mutate, isLoading } = useMutation(saveImageReq, {
		onSuccess: (data) => {
			const updatedImages = images.slice();
			const index = images.findIndex((item) => item._id == imageId);
			const img = {
				_id: data._id,
				title: title,
				url: data.url,
				url_low_res: data.url_low_res,
				info: info,
				photographer: photographer,
				source: source,
				location: location,
				date: date,
				isComplete: true,
				quotes: quotes
			};
			updatedImages[index] = img;

			setImages(updatedImages);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully updated image info.'
				})
			);

			setIsChanged(false);
			setModalOpen(false);
		},
		onError: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't update image info."
				})
			);
		}
	});

	const saveImage = () => {
		if (quotes != null)
			for (let index = 0; index < quotes.length; index++) {
				const quote = quotes[index];
				if (
					validator.isEmpty(quote.content, { ignore_whitespace: true })
					// ||
					// validator.isEmpty(quote.metadata, { ignore_whitespace: true })
				) {
					dispatch(
						SetNotificationAction({
							type: stateNotificationsEnum.ERROR,
							message: 'Please fill the empty quote fields!'
						})
					);
					return;
				}
			}
		mutate();
	};

	const verifTitle = (name = '') => {
		if (validator.isEmpty(name, { ignore_whitespace: true })) {
			setTitleErrorMsg({
				error: true,
				message: 'Please enter a valid title.'
			});
		}
	};

	const addQuote = () => {
		setQuotes([
			...quotes,
			{
				index: Math.floor(Math.random() * 100000),
				content: '',
				metadata: ''
			}
		]);
	};

	return (
		<div>
			{/* {isWarning && <WarnModal isWarn={isWarning} setIsWarn={setIsWarning} />} */}

			<div
				className="relative inline-block align-bottom bg-white dark:bg-gray-800 rounded-lg text-left
                                       shadow-xl transform transition-all sm:align-middle
                                      sm:w-8/12 w-full sm:ml-20 ml-16 max-h-[85vh] overflow-scroll"
			>
				<section>
					<div className="w-8/12 mx-auto">
						<form className="mx-auto w-full max-w-3xl mt-8">
							<div className="flex flex-wrap -mx-3 mb-6">
								<div className="w-full px-3">
									<label
										className="block uppercase tracking-wide text-gray-700
																		dark:text-gray-300 text-xs font-bold mb-2"
									>
										Title
									</label>
									<input
										className={`appearance-none block w-full py-3 px-4 rounded font-semibold
															text-gray-700 dark:text-white placeholder-gray-500 dark:placeholder-gray-500
															bg-gray-300 dark:bg-gray-700 border focus:outline-none focus:border-gray-400
															dark:focus:border-gray-600 ${
																titleErrorMsg.error
																	? 'border-red-500'
																	: 'border-gray-200 dark:border-gray-700'
															}`}
										id="grid-title"
										placeholder="Image title"
										onBlur={() => {
											verifTitle(title);
										}}
										onFocus={() => {
											setTitleErrorMsg({
												error: false,
												message: ''
											});
										}}
										onChange={(e) => {
											setTitle(e.target.value);
											setIsChanged(true);
										}}
										value={title}
									/>
									{titleErrorMsg.error ? (
										<p className="text-red-500 text-xs italic">
											Please fill out this field.
										</p>
									) : (
										<p className="text-gray-600 dark:text-gray-500 text-xs italic">
											Required
										</p>
									)}
								</div>
							</div>

							<div className="flex flex-wrap -mx-3 mb-6">
								<div className="w-full px-3">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Info
									</label>
									<textarea
										className="inputStyle"
										id="grid-photographer"
										placeholder="John Doe"
										onChange={(e) => {
											setInfo(e.target.value);
											setIsChanged(true);
										}}
										value={info}
									/>
									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
							</div>
							<div className="flex flex-wrap -mx-3 mb-6">
								<div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Location
									</label>
									<input
										className="inputStyle"
										id="grid-first-name"
										type="text"
										placeholder="Paris, France"
										onChange={(e) => {
											setLocation(e.target.value);
											setIsChanged(true);
										}}
										value={location}
									/>
									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
								<div className="w-full md:w-1/2 px-3">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Photographer
									</label>
									<input
										className="inputStyle"
										id="grid-last-name"
										type="text"
										placeholder="Additional info"
										onChange={(e) => {
											setPhotographer(e.target.value);
											setIsChanged(true);
										}}
										value={photographer}
									/>
									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
							</div>

							<div className="flex flex-wrap -mx-3 mb-6">
								<div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Source
									</label>
									<input
										className="inputStyle"
										id="grid-first-name"
										type="text"
										placeholder="www.example.com"
										onChange={(e) => {
											setSource(e.target.value);
											setIsChanged(true);
										}}
										value={source}
									/>
									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
								<div className="w-full md:w-1/2 px-3">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Date
									</label>

									<DatePickerComponent
										date={date}
										setDate={setDate}
										setIsChanged={setIsChanged}
									/>

									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
							</div>
						</form>
					</div>
					<div className="border-t mt-8 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center w-8/12 mx-auto" />

					{quotes.length > 0 ? (
						<div className="text-center mt-5">
							<div className="flex flex-row">
								<div className="flex-1"></div>
								<h3 className="flex-1 text-2xl font-semibold text-gray-600 dark:text-gray-400">
									Quotes
								</h3>
								<div className="flex flex-1 justify-end">
									<button
										className="btn btn-outline btn-sm btn-primary ml-auto mt-1 mr-8"
										onClick={() => {
											addQuote();
										}}
									>
										Add Quote ➕
									</button>
								</div>
							</div>
							{quotes.map((quote, index) => (
								<Quote
									key={quote.index}
									index={index}
									id={quote._id}
									quote={quote.content}
									isMine={true}
									metadata={quote.metadata}
									quotes={quotes}
									setQuotes={setQuotes}
									setIsChanged={setIsChanged}
								/>
							))}
						</div>
					) : (
						<div className="flex flex-1 my-5">
							<button
								className="btn btn-outline btn-sm btn-primary mx-auto"
								onClick={() => {
									addQuote();
								}}
							>
								Add Quote ➕
							</button>
						</div>
					)}
					<div className="h-1"></div>
				</section>
				<div className="bg-white dark:bg-gray-800 px-4 pb-3 sm:px-6 flex flex-row-reverse">
					{isChanged && (
						<SaveButton isSaving={isLoading} saveFunc={() => saveImage()} />
					)}
					<button
						type="button"
						className="btn btn-outline btn-sm btn-error mr-2"
						onClick={() => {
							if (isChanged) setIsWarnModalOpen(true);
							else setModalOpen(false);
						}}
						ref={cancelButtonRef}
					>
						Cancel
					</button>
				</div>
			</div>
		</div>
	);
}
